export const StreetMapLevelEnum = {
    LEVEL_1: ['extNumber', 'street', 'city', 'state', 'zipCode', 'country'],
    LEVEL_2: ['extNumber', 'street', 'city', 'state', 'country'],
    LEVEL_3: ['extNumber', 'street', 'city', 'zipCode', 'country'],
    LEVEL_4: ['extNumber', 'street', 'city', 'country'],
    LEVEL_5: ['street', 'city', 'state', 'country'],
    LEVEL_6: ['street', 'city', 'zipCode', 'country'],
    LEVEL_7: ['extNumber', 'street', 'zipCode', 'country'],
    LEVEL_8: ['extNumber', 'street', 'country'],
    LEVEL_9: ['extNumber', 'street', 'state', 'country'],
    LEVEL_10: ['extNumber', 'state', 'zipCode', 'country']
}